import { Validator } from './Validator';
export class ForwardMessageToDeskActionSettingsValidator extends Validator {
    validate(model) {
        //As there is no validation of the fields, the card validation was removed, according to BUG 201077.
    }
}
